module.exports = __webpack_public_path__ + "img/5de50b7.png";